
import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Footer from "@/components/Footer";

const Privacy = () => {
  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Privacy Policy - Fly Local Boost</title>
        <meta name="description" content="Read our Privacy Policy to understand how Fly Local Boost collects, uses, and protects your personal information and data." />
        <meta name="keywords" content="privacy policy, data protection, personal information, data security" />
        <link rel="canonical" href="https://fly-social.com/privacy" />
      </Helmet>
      {/* Stripped header — sticky Fly logo only, no nav links. */}
      <div className="fixed top-0 left-0 right-0 z-50 px-6 lg:px-10 pt-6 pointer-events-none">
        <a href="/" className="inline-flex items-center pointer-events-auto" aria-label="Fly — Privacy">
          <img
            src="/lovable-uploads/2e7bf5aa-9c7b-41ea-b64a-48b87f3dc01d.png"
            alt="Fly"
            className="h-16 md:h-20 drop-shadow-[0_2px_8px_rgba(0,0,0,0.12)]"
          />
        </a>
      </div>
      
      <div className="container mx-auto px-4 pt-24 md:pt-32 pb-12">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
          
          <div className="prose prose-lg">
            <p className="text-gray-600">Last updated: May 15, 2025</p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">1. Introduction</h2>
            <p>
              At Fly, we respect your privacy and are committed to protecting your personal data. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our platform.
            </p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">2. Information We Collect</h2>
            <p>
              <strong>Personal Information:</strong> We collect information that you provide directly to us when registering for an account, using our services, or contacting our support team. This may include your name, email address, phone number, business information, and payment details.
            </p>
            <p>
              <strong>Usage Information:</strong> We automatically collect certain information about your device and how you interact with our platform, including your IP address, browser type, referring/exit pages, and operating system.
            </p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">3. How We Use Your Information</h2>
            <p>
              We use the information we collect to:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>Provide, maintain, and improve our services</li>
              <li>Process transactions and send related information</li>
              <li>Send you technical notices, updates, and support messages</li>
              <li>Respond to your comments, questions, and requests</li>
              <li>Monitor and analyze trends, usage, and activities in connection with our platform</li>
              <li>Detect, investigate, and prevent fraudulent transactions and other illegal activities</li>
              <li>Personalize and improve your experience on our platform</li>
            </ul>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">4. Sharing Your Information</h2>
            <p>
              We do not sell your personal information to third parties. We may share your information with:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>Service providers who perform services on our behalf</li>
              <li>Business partners with whom we jointly offer products or services</li>
              <li>Legal authorities when required by law or to protect our rights and safety</li>
            </ul>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4">5. Data Deletion Requests</h2>
            <p>
              You have the right to request deletion of your personal data. To request data deletion:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li><strong>Email Request:</strong> Send an email to <a href="mailto:fly@zoomlocal.in" className="text-fly-purple hover:underline">fly@zoomlocal.in</a> with the subject line "Data Deletion Request"</li>
              <li><strong>Include Information:</strong> Please include your account email address and specify which data you want deleted</li>
              <li><strong>Verification:</strong> We may ask you to verify your identity before processing the deletion request</li>
              <li><strong>Processing Time:</strong> We will process your request within 30 days of verification</li>
              <li><strong>Confirmation:</strong> You will receive confirmation once your data has been deleted</li>
            </ul>
            <p>
              Please note that some information may need to be retained for legal compliance, security purposes, or to complete transactions you have requested.
            </p>
            
            <div className="my-8">
              <Link to="/" className="text-fly-purple hover:underline">
                Return to Home
              </Link>
            </div>
          </div>
        </div>
      </div>
      
      <Footer compact />
    </div>
  );
};

export default Privacy;
